import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

/**
 * This function is used to get the translation key for the plan state.
 * @param state
 * @returns
 */
export function getPlanStateString(state: Enums<"planState"> | undefined): TranslationKey {
	switch (state) {
		case "editing":
			return "planning.editing";
		case "published":
			return "planning.published";
		case "pending":
			return "planning.pending";
		default:
			return "general.loading";
	}
}
